import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Field } from '@adornis/baseql/decorators.js';
import { Entity } from '@adornis/baseql/decorators/entity.js';
import type { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { View } from '@adornis/data-view/db/view.js';
import { FieldConfiguration } from '@adornis/field-management/field-configuration.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import type { DataViewConfigKey } from '@ils/static/enums.js';
import { Names } from '@ils/static/names.js';
import { UserConfig } from './user-config.js';

@Entity()
export class DataViewConfig<T extends typeof AdornisEntity> extends UserConfig {
  public static override _class = Names.DataViewConfig._class;

  @Field(type => View, {
    default: v => v ?? new View({}),
  })
  public view: Maybe<View<T>>;

  public static override getDefault(key: DataViewConfigKey) {
    switch (key) {
      case 'user-export-line':
        return new DataViewConfig({
          key,
          view: new View({
            _id: A.getGloballyUniqueID(),
            filter: new AdornisFilter({
              searchFields: ['user.ecommerce.firstName', 'user.ecommerce.lastName', 'user.email'],
            }),
            configuredColumns: [
              new FieldConfiguration({ fieldName: 'user.email' }),
              new FieldConfiguration({ fieldName: 'user.ecommerce.firstName' }),
              new FieldConfiguration({ fieldName: 'user.ecommerce.lastName' }),
            ],
          }),
        });
      case 'user-basic-data':
        return new DataViewConfig({
          key,
          view: new View({
            _id: A.getGloballyUniqueID(),
            filter: new AdornisFilter({
              searchFields: ['user.ecommerce.firstName', 'user.ecommerce.lastName', 'user.email', 'user.username'],
            }),
            configuredColumns: [
              new FieldConfiguration({ fieldName: 'user.email' }),
              new FieldConfiguration({ fieldName: 'user.ecommerce.firstName' }),
              new FieldConfiguration({ fieldName: 'user.ecommerce.lastName' }),
              new FieldConfiguration({ fieldName: 'user.username' }),
            ],
          }),
        });
      case 'rating-export': // TODO
        return new DataViewConfig({
          key,
          view: new View({
            _id: A.getGloballyUniqueID(),
            filter: new AdornisFilter({
              searchFields: [
                'inspectors.ecommerce.firstName',
                'inspectors.ecommerce.lastName',
                'inspectors.email',
                'trainee.ecommerce.firstName',
                'trainee.ecommerce.lastName',
                'trainee.email',
              ],
            }),
            configuredColumns: [
              new FieldConfiguration({ fieldName: 'inspectors.email' }),
              new FieldConfiguration({ customID: 'inspectors.ecommerce.fullName' }),
              new FieldConfiguration({ fieldName: 'inspectors.username' }),
              new FieldConfiguration({ fieldName: 'ratingDoc.ratings.score' }),
            ],
          }),
        });
    }
  }
}
